import { IEnquiryPayload } from "Interfaces/interface.enquirypayload";
import ecomInterceptor from "../interceptors/ecomInterceptor";

const enquiryFormService = {
  submitEnquiry: async (payload: IEnquiryPayload): Promise<any> => {
    try {
      const response = await ecomInterceptor.post("/enquiry", payload);
      return response.data.data;
    } catch (error: any) {
      throw new Error(`Failed to submit enquiry: ${error.message}`);
    }
  },
};

export default enquiryFormService;
